import { render, staticRenderFns } from "./LeicesterAlerts.vue?vue&type=template&id=62419725&"
import script from "./LeicesterAlerts.vue?vue&type=script&lang=js&"
export * from "./LeicesterAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports